import { Action, createReducer, on } from '@ngrx/store'
import { DashboardState, initialDashboardState } from '../state/dashboard.state'
import { FETCH_DASHBOARD_INFO_SUCCESS } from '../action/dashboard.action'

export function dashboardReducer(state: DashboardState, action: Action) {
  return _dashboardReducer(state, action)
}

const _dashboardReducer = createReducer(
  initialDashboardState,
  on(FETCH_DASHBOARD_INFO_SUCCESS, (state, { dashboardInfo }) => {
    return {
      ...state,
      dashboardInfo
    }
  })
)
